module.exports = __webpack_public_path__ + "img/platform.74285134.svg";